import {Component, Input} from "@angular/core";

@Component({
  selector: "[pcg-ng-json-data]",
  template: require('./json-data.component.html'),
  styles: [
    ".pcg-json-data {" +
        "padding: 5px;" +
        "font-size: 14px;" +
        "background: #eeeeee;" +
    "}" +
    ".pcg-json-data__title {" +
        "margin:0;" +
        "border: 1px dotted #c7c6c5;"+
        "text-align: center;" +
        "font-size: 1em;" +
        "cursor: pointer;" +
    "}" +
    ".pcg-json-data__raw {" +
        "margin: 0;" +
        "line-height: 14px;" +
        "white-space: pre-wrap;" +
    "}"
  ]
})
export class JsonDataComponent {
    @Input()
    public "pcg-ng-json-data": any;

    public expanded: boolean = true;

    public get data(): any {
        return this["pcg-ng-json-data"];
    }

    public toggle(): void {
        this.expanded = !this.expanded;
    }
}
